module.exports = __webpack_public_path__ + "static/media/GAMBOA.04e2b1ae.png";